import {
  getAccessToken,
  useControlLockHeartbeat,
  useSessionBootstrap,
  useStreamBridge,
  useStreamProgressReset,
  useStreamResync,
} from '@ctcells/api'
import { configureStreamAuth, useStreamState, useStreamSubscribe } from '@ctcells/realtime'
import { useEffect } from 'react'

/**
 * 앱 셸의 런타임 배선. **화면이 아니다** — 아무것도 그리지 않는다.
 *
 * 네 가지를 한다.
 *   1. **세션 부트스트랩** — 저장된 refresh 토큰으로 조용히 갱신하고, 만료 전에 미리 갱신한다.
 *   2. **구독 자격 주입** — 소켓 핸드셰이크에 쓸 토큰을 읽는 **방법**을 realtime 에 건넨다.
 *   3. **구독 → 캐시 다리** — 원시 이벤트를 받아 **무효화만** 한다(덮어쓰지 않는다 · DP-04).
 *   4. **제어락 리스 갱신** — 락을 쥔 동안만 도는 lease 연장 타이머. 화면이 바뀌어도 끊기면 안 되므로
 *      여기가 주인이다. ⚠ **폴링이 아니다**(DP-01) — 상태 조회가 아니라 명령이고, 락이 없으면 0건이다.
 *   5. **끊기면 진행을 버린다** — 구독에만 있는 축(`batch_progress`)은 REST 로 되찾을 수 없어
 *      보관소에 쌓인다. 채널이 stale 이면 그 마지막 값이 「지금」인 척하게 되므로 그 자리에서 비운다.
 *
 * 🔴 넷 다 라우터보다 위에 있다. 화면이 바뀌어도 연결과 세션은 유지된다(연결의 주인은 앱 셸).
 * 🔴 `@ctcells/realtime` 은 쿼리 키를 모르고, `@ctcells/api` 는 소켓을 모른다. **여기서만 만난다** —
 *    그것도 「구독 함수를 넘겨주는」·「토큰 읽는 법을 넘겨주는」 두 줄뿐이고,
 *    캐시를 만지는 코드는 전부 api 안에, 소켓을 만지는 코드는 전부 realtime 안에 있다.
 */
export function AppRuntime() {
  useSessionBootstrap()

  // 🔴 **토큰 값이 아니라 읽는 함수를 넘긴다.** 값으로 넘기면 재연결할 때 만료된 토큰을 다시 쓴다.
  //    realtime 은 매 연결 시도마다 이걸 불러 그 시점의 토큰을 얻는다.
  useEffect(() => {
    configureStreamAuth(getAccessToken)
    return () => {
      configureStreamAuth(null)
    }
  }, [])

  useStreamBridge(useStreamSubscribe())
  const eventsStale = useStreamState('events').stale
  // 🔴 realtime 이 「끊겼다」고 말하면 api 가 보관한 진행을 버린다. 두 패키지는 여전히 서로를
  //    모르고, 여기서 **사실 하나를 옮겨 주기만** 한다
  useStreamProgressReset(eventsStale)
  // 🔴 다시 붙으면 끊긴 동안 놓친 장비 · 시료 · 작업 변화를 REST 로 한 번 다시 맞춘다(eric 2026-10-06 · `useStreamResync`)
  useStreamResync(eventsStale)
  useControlLockHeartbeat()
  return null
}
